var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "product-item__quick-add--custom",
      on: { click: _vm.onclick }
    },
    [
      _c("a", { staticClass: "product-item__quick-add__text" }, [
        _vm._v("Quick Add")
      ]),
      _vm._v(" "),
      _c("span", { staticClass: "product-item__quick-add__plus" }, [
        _vm._v("+")
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }